module.exports = __webpack_public_path__ + "img/da88ce17b665c25a351f474698ad2ddc.png";